import { accordion } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'accordion',
  label: 'Accordion',
  category: 'Surfaces',
  image: accordion
};
